import { render, staticRenderFns } from "./survey-step-highest-cholesterol-level.vue?vue&type=template&id=83d6a03a"
import script from "./survey-step-highest-cholesterol-level.vue?vue&type=script&lang=js"
export * from "./survey-step-highest-cholesterol-level.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports